import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import ScrollToTop from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Galeria from "@/pages/Galeria";
import Depoimentos from "@/pages/Depoimentos";
import Orcamento from "@/pages/Orcamento";
import TrabalheConosco from "@/pages/TrabalheConosco";
import Contato from "@/pages/Contato";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/depoimentos" element={<Depoimentos />} />
            <Route path="/orcamento" element={<Orcamento />} />
            <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
